import { useQuery } from '@tanstack/react-query'
import { api } from '../../api'

export interface ForecastDay {
  date: string
  predicted_score: number
  baseline_score: number
  delta: number
  rationale: string
  phase: string | null
  confidence: number
}

export interface PainForecastResponse {
  forecast: ForecastDay[]
  llm_used: boolean
  message?: string
}

export function usePainForecast(enabled: boolean = true) {
  return useQuery({
    queryKey: ['patient', 'pain-forecast'],
    queryFn: () => api.get<PainForecastResponse>('/api/patient/pain-forecast?days=5'),
    enabled,
    // Forecast is cheap-ish (one small LLM call) but not free — hold it for
    // the session unless the user reloads.
    staleTime: 15 * 60_000,
  })
}
